import clsx from 'clsx';
import React from 'react';
import { useWorkspace } from 'wrappers/WorkspaceProvider';

export const PaymentsWorkspaceSwitcher = ({
  disabled = false,
  onToggleMenu,
}: {
  disabled?: boolean;
  onToggleMenu: () => void;
}) => {
  const { workspace: currentWorkspace } = useWorkspace();

  return (
    <button
      type="button"
      onClick={onToggleMenu}
      disabled={disabled}
      className="p-0 m-0 text-xmd leading-[1]"
      data-testid="payments-ws-switcher"
    >
      <span
        className={clsx(
          'flex items-center h-fit max-w-f16 font-normal transition-colors text-xmd font-helvetica',
          'text-main hover:text-main-500'
        )}
      >
        <span className="truncate">
          {currentWorkspace?.name || 'Select a Workspace'}
        </span>
      </span>
    </button>
  );
};
